export default [
  {
    leistungstext: "Hausratschäden durch Brand, Blitzschlag, Explosion, Sturm, Hagel, Leitungswasser",
    infoText:
      "<strong>Brand</strong> – Feuer, das ohne bestimmungsgemäßen Herd (z. B. Kamin usw.) entstanden ist oder ihn verlassen hat und das sich aus eigener Kraft auszubreiten vermag.<br />" +
      "<strong>Blitzschlag</strong> – Unmittelbarer Übergang eines Blitzes auf Gebäude/Gegenstände.<br />" +
      "<strong>Explosion</strong> – Spontane Freisetzung großer Energiemengen auf kleinem Raum.<br />" +
      "<strong>Sturm</strong> – Wetterbedingtes &quot;Starkwindereignis&quot; von mindestens Windstärke 8 nach der Beaufortskala (Windgeschwindigkeit min. 62 km/h).<br />" +
      "<strong>Hagel</strong> – Fester Witterungsniederschlag in Form von Eiskörnern.<br />" +
      "<strong>Leitungswasser</strong> – &quot;Bestimmungswidrig&quot; ausgetretenes Wasser z. B. aus:" +
      "<ul><li>Rohren der Wasserversorgung (Zu- und Ableitungen),</li><li>Heizungs- oder Klimaanlagen,</li><li>Wasserlöschanlagen,</li><li>Wasserbetten oder Aquarien.</li></ul>",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "Überspannungsschäden durch Blitz",
    infoText:
      "<strong>Überspannungsschäden</strong> - Schäden an elektrischen Einrichtungen oder Geräten durch Überspannung, Überstrom oder Kurzschluss, ausgelöst durch einen Blitzschlag.",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "Einbruchdiebstahl, Raub, Vandalismus nach Einbruch",
    infoText:
      "<strong>Einbruchdiebstahl</strong> – Besonders schwerer Fall des Diebstahls der durch gewaltsamen oder erschlichenen, in jedem Fall aber unbefugten, Zutritt in einen Raum erreicht wird. Dabei ist es z. B. unerheblich ob der Zutritt mit einem falschen oder richtigen Schlüssel geschah. Beides ist versichert.<br />" +
      "<strong>Raub</strong> – Gegen Sie als Person angewendete Gewalt, um gegen Ihren Widerstand an Ihre mitgeführten Sachen zu gelangen.<br />" +
      "<strong>Vandalismus</strong> – Die vorsätzliche Beschädigung oder Zerstörung von Hausrat nach Einbruch in die versicherte Wohnung.",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "Steckersolaranlagen für Balkone (Balkonkraftwerke) bis 2 kWp",
    infoText:
      "<strong>Steckersolaranlagen</strong> - Privat genutzte Balkonkraftwerke, die  ausschließlich  der versicherten  Wohnung dienen. Diese müssen sich auf dem Grundstück befinden, auf dem die versicherte Wohnung liegt.",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "Nebengebäude, Garagen, Keller",
    infoText: "",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "Wertsachen",
    infoText:
      "<strong>Wertsachen</strong> sind z. B.:" +
      "<ul><li>Bargeld sowie Geldbeträge auf Karten oder sonstigen Datenträgern</li><li>Sparbücher und sonstige Wertpapiere</li><li>Schmucksachen, Edelsteine, Perlen, Urkunden, Briefmarken, Münzen</li><li>Pelze, handgeknüpfte Teppiche, Gobelins und Kunstgegenstände</li><li>Antiquitäten, die über 100 Jahre alt sind (mit Ausnahme von Möbelstücken)</li></ul>",
    berechnung: true,
    leistungen: ["20%", "30%", "40%"],
  },
  {
    leistungstext: "Versicherung Ihres Hausrates außerhalb Ihrer Wohnung (Außenversicherung)",
    infoText:
      "<strong>Außenversicherung</strong> - Weltweiter Versicherungsschutz für versichertes Eigentum, dass sich (wie z. B. bei Urlaubsreisen) vorübergehend außerhalb des Versicherungsortes befindet.<br />" +
      "<u>Beispiel:</u> In Ihr Hotelzimmer oder Ferienhaus wird eingebrochen.",
    berechnung: true,
    leistungen: ["10% (bis 3 Monate)", "50% (bis 6 Monate)", "100% (bis 12 Monate)"],
  },
  {
    leistungstext: "Hotelkosten",
    infoText:
      "<strong>Hotelkosten</strong> - Kosten, die bei einer Hotel- oder ähnlichen Unterbringung entstehen, wenn die eigene Wohnung durch einen Schaden unbewohnbar sein sollte. Diese werden bis zur erneuten Bewohnbarkeit der Wohnung übernommen.",
    leistungen: ["75 € (max. 100 Tage)", "100 € (max. 200 Tage)", "Ja"],
  },
  {
    leistungstext: "Grobe Fahrlässigkeit",
    infoText:
      "Grob fahrlässig handelt, wer es an der nötigen Umsichtigkeit und Sorgfalt fehlen lässt und in hohem Maß unbedacht und unvorsichtig agiert. Grobe Fahrlässigkeit kann beispielsweise vorliegen, wenn eine brennende Kerze über einen längeren Zeitraum unbeaufsichtigt bleibt oder eine Wohnungstür bei längerer Abwesenheit nur zugezogen und nicht verschlossen wird.",
    leistungen: ["Schäden bis 1.000 €", "Ja", "Ja"],
  },
  {
    leistungstext: "Datenrettungskosten",
    infoText:
      "<strong>Datenrettungskosten</strong> - Kosten für die technische Wiederherstellung von elektronisch gespeicherten privaten Daten und Programmen nach Beschädigung des Datenträgers.",
    leistungen: ["Nein", "Ja", "Ja"],
  },
  {
    leistungstext: "Konflikte mit Onlinehändlern",
    infoText:
      "<strong>Konflikte mit Onlinehändlern</strong> - Absicherung von Vermögensschäden, die Privatpersonen beim Onlinekauf entstehen können, wenn die bestellte Ware nicht geliefert wird.",
    leistungen: ["Nein", "Nein", "3.000 €"],
  },
  {
    leistungstext: "Räuberische Erpressung",
    infoText:
      "Unter Anwendung oder Androhung von Gewalt werden auf Verlangen des Täters versicherte Sachen an den Ort der Tathandlungen herangeschafft. Dies gilt unabhängig davon, ob die Tathandlung am Versicherungsort oder außerhalb verübt wird.",
    leistungen: ["Nein", "5.000 €", "Ja"],
  },
  {
    leistungstext: "Mehrkosten für energieeffiziente Haushaltsgeräte",
    infoText:
      "Das sind Mehrkosten, die dadurch entstehen, dass bei folgenden, neu zu beschaffenden Haushaltsgeräten die verfügbare höchste Effizienzklasse gewählt wird: wasser- bzw. energiesparende Waschmaschinen oder Waschtrockner, Trockner, Kühlschränke, Gefrierschränke bzw. -truhen und Geschirrspüler",
    leistungen: ["Nein", "500 €", "Ja"],
  },
  {
    leistungstext: "Unbenannte Gefahren",
    infoText:
      "<strong>Unbenannte Gefahren</strong> sind alle Schadenursachen,die trotz erforderlicher Sorgfalt, unvorhersehbar eintreten, und die nicht ausdrücklich ausgeschlossen sind.",
    leistungen: ["Nein", "Nein", "Ja"],
  },
];
